(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('buyCreateUserCtrl', [
    '$scope',
    '$state',
    '$rootScope',
    'buyService',
    'uteModal',
    'emailValidationService',
    'commonService',
    'cartManager',
    '$translate',
    'notifier',
    '$modal',
    'dtmService',
    'dtmServiceConstants',
    '$timeout',
    'brtSwitchCMS',
    function(
      $scope,
      $state,
      $rootScope,
      buyService,
      uteModal,
      emailValidationService,
      commonService,
      cartManager,
      $translate,
      notifier,
      $modal,
      dtmService,
      dtmServiceConstants,
      $timeout,
      brtSwitchCMS
    ) {
      var _self = this;

      _self.billingAddress = {};
      $scope.loggedIn = false;
      $scope.addressNotMailable = null;
      $scope.hasBeenSubmitted = false;
      $scope.addNewClass = false;

      $scope.customerHasWirelessService = commonService.customerHasWirelessService;

      if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
        if (buyService.getCartContext() !== 'tv' && commonService.customerHasInternetService) {
          cartManager.cleanCart(false);
          $state.go('internet');
        } else {
          $scope.loggedIn =
            ($rootScope.ruiMethods.user.is.loggedIn() && !_.result($scope.forms, 'createUser.formEditable', false)) ||
            ($rootScope.ruiMethods.user.is.agent() &&
              $rootScope.ruiMethods.agent &&
              $rootScope.ruiMethods.agent.has.customerContext() &&
              !_.result($scope.forms, 'createUser.formEditable', false));

          $scope.phoneNumRetrieved = !!$scope.forms.createUser.phone;
        }
      }
      //FUSS-1513 - DTM tracking for buy create user
      var tierInCart = cartManager.internet.tierInCart();
      if (tierInCart) {
        if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
          dtmService.setVar(dtmServiceConstants.dtmRules.buyInternet.selectedProduct, tierInCart.selectedOffer.offerId);
          dtmService.setVar(
            dtmServiceConstants.dtmRules.buyInternet.productPrice,
            tierInCart.selectedOffer.offerPrice.price
          );
        }
        dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.checkout.ruleName);

        /* DSO-15392 start */
        // $timeout(function(){
        if ($rootScope.promoOfferId === null || $rootScope.discountOffers === null) {
          if (
            commonService.customerHasInternetService &&
            commonService.internetAccountStatus !== 'SUSPENDED' &&
            commonService.internetAccountStatus !== 'CANCELLED'
          ) {
          } else {
            var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
            if (isOfferIdEligible === null) {
              buyService.getInternetPromos().then(function(data) {
                if (data) {
                  isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                  $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $rootScope.discountOffers = buyService.getDiscountOffers();
                }
              });
            } else {
              $rootScope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
              $rootScope.discountOffers = buyService.getDiscountOffers();
            }
          }
        } else if (tierInCart && $rootScope.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn()) {
          buyService.getInternetPromos().then(function(data) {
            $scope.discountOffers = data;
          });
        }
        //});
        /* DSO-15392 end */
      }

      $scope.createUser = $scope.forms.createUser;

      $scope.createUserRule = {
        firstName: { type: 'text', pattern: '([a-zA-Z0-9\\- ]{2,50})' },
        lastName: { type: 'text', pattern: '([a-zA-Z0-9\\- ]{2,50})' },
        email_address: { pattern: '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$' },
        password: { type: 'text', minlength: 7, maxlength: 16 },
        confirmPassword: { type: 'text' },
        secretQuestion: { required: 'false' },
        secretQuestionAns: { type: 'text', minlength: 2, maxlength: 50 },
        phone: {
          pattern:
            '(^\\d{3}\\d{3}\\d{4}$)|(^\\d{3}\\s\\d{3}\\s\\d{4}$)|(^\\d{3}\\.\\d{3}\\.\\d{4}$)|(^\\d{3}-\\d{3}-\\d{4}$)'
        },
        phoneType: {}
      };

      if (!$rootScope.ruiMethods.user.is.agent()) {
        $scope.createUserRule.confirmEmail = {
          pattern: '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$'
        };
      }

      // TODO: centralize pca methods
      $scope.setAddressData = function(address) {
        _self.billingAddress = {
          city: address.City,
          province: address.Province,
          postalCode: address.PostalCode,
          country: address.CountryName,
          streetNumber: address.Field1,
          streetName: address.Field2,
          streetType: address.Field3.toUpperCase(),
          unitNumber: address.SubBuilding,
          streetDirection: address.Field7.toUpperCase()
        };

        if (address.POBoxNumber) {
          _self.billingAddress.poBox = address.Line1;
        }

        $scope.createUser.anotherBillingAddress = address.Label;
        $scope.address = address.Label;
        $scope.$apply();
      };
      $scope.PCAError = function() {
        $scope.PCANotAvailable = true;
      };
      $scope.PCANotFound = function() {
        _.each(document.querySelectorAll('.pca .pcaautocomplete.pcatext'), function(el) {
          el.style.display = 'none';
        });
        $scope.addressNotFound = true;
        $scope.$apply();
      };

      // TODO: restruct
      $scope.isValidAddress = function(ev) {
        // reset input validity to true as soon as user changed input field value
        $scope.createUserForm.anotherBillingAddress.$setValidity('addressNotMailable', true);

        console.log('@isValidAddress: _self.billingAddress ', _self.billingAddress);

        if (ev.keyCode === 13 && !$scope.createUser.anotherBillingAddress) {
        } else {
          $scope.address = null;
          $scope.addressNotFound = false;
        }
      };

      var openDecisionModal = function(displayMessage) {
        var modalInstance = $modal.open({
          templateUrl: 'modules/checkout/views/decision-modal.html',
          controller: 'decisionModalCtrl',
          scope: $scope,
          resolve: {
            data: function() {
              return {
                formData: $scope.createUser,
                displayMessage: displayMessage,
                parent: null,
                processRoute: null,
                showNewCustomerButton: false,
                focusEmail: focusEmail
              };
            }
          }
        });

        // uteModal.open({
        //   templateUrl: 'modules/checkout/views/decision-modal.html',
        //   controller: 'decisionModalCtrl',
        //   size: 'md',
        //   resolve: {
        //     formData: $scope.createUser,
        //     displayMessage: displayMessage,
        //     parent: null,
        //     processRoute:null,
        //     showNewCustomerButton: false
        //   }
        // });
      };

      $scope.createUserComplete = function(param) {
        console.log('DSA>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', param);
        return completeOrderHsi(param);
        // if (buyService.getCartContext() == 'tv') {
        //   completeOrderTv();
        // } else {
        //   return completeOrderHsi(param);
        // }
      };
      $scope.changeSubmittedValue = function() {
        $scope.addNewClass = true;
        $scope.hasBeenSubmitted = true;
      };
      $scope.toggleSubmittedValue = function() {
        $scope.hasBeenSubmitted = false;
      };

      $scope.processCreateUser = function() {
        if (
          $scope.createUser.billingAddress === 'anotherAddress' ||
          ($rootScope.ruiMethods.user.is.loggedIn() && $scope.createUser.billingAddress !== 'serviceAddress')
        ) {
          if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
            _self.billingAddress = $scope.forms.createUser.data.existingBillingAddress.address || _self.billingAddress;
          }

          buyService.searchAddress(_self.billingAddress, 'billing').then(
            function(res) {
              console.log('>>>>', res, res.error);
              if (res.error) {
                notifier.notify.done();
                $scope.addressNotMailable = true;
                if ($scope.createUserForm.anotherBillingAddress)
                  $scope.createUserForm.anotherBillingAddress.$setValidity('addressNotMailable', false);
              } else {
                // close processing modal
                notifier.notify.done();

                // proceed to credit check
                // set another billing address

                // old implementation, clean up this
                $scope.forms.createUser.data.anotherBillingAddress = { address: _self.billingAddress };

                // tbd
                angular.extend($scope.forms.createUser.data, { billingAddress: _self.billingAddress });

                $scope.completedForm('createUser');
              }
            },
            function(res) {
              // handle error
              //Should: invalidate form if address is not mailable
              $scope.addressNotMailable = true;
              if ($scope.createUserForm.anotherBillingAddress)
                $scope.createUserForm.anotherBillingAddress.$setValidity('addressNotMailable', false);
              console.log('searchAddress:rejected ', res);
            }
          );
        } else {
          // close processing modal
          notifier.notify.done();

          // proceed to credit check
          $scope.completedForm('createUser');
        }
      };

      function completeOrderTv() {
        var _tvRequestData = {}; // TODO
        buyService.getOrderSummary(_tvRequestData).then(
          function(res) {
            angular.extend($scope.forms.review.data, res);
            $scope.completedForm($state.current.name);
            $scope.completedForm('creditCheck');
            $scope.completedForm('fulfillment');
            $scope.completedForm('paymentOptions');
          },
          function(res) {}
        );
      }

      function completeOrderHsi(formName) {
        //DSO-12647 scroll to the first error
        var errorList = document.getElementsByClassName('ute-message error ng-active');
        if (errorList.length > 0) {
          var iElement = 0;
          while (errorList[iElement].getClientRects().length <= 0 && errorList.length > iElement) {
            iElement++;
          }
          if (errorList[iElement] && errorList[iElement].getClientRects().length > 0) {
            var yPos = errorList[iElement].getClientRects()[0].top;
            var scrollValue =
              yPos -
              document.getElementsByClassName('create-profile-menu-holder')[0].offsetHeight -
              document.getElementById('header').offsetHeight -
              95;
            window.scrollBy(0, scrollValue);
          }
        }
        // dont submit if form is invalid and allow angular to show form invalid messages
        if ($scope[formName].$invalid) {
          console.log('createUserComplete ', $scope);
          return;
        }

        // process to prevent a user to click the button more than one times.
        _self.isEmailValidationInProcess = _self.isEmailValidationInProcess || false;

        if (_self.isEmailValidationInProcess) return;

        _self.isEmailValidationInProcess = true;

        var that = _self;

        // debug
        // $scope.processCreateUser();
        // return;
        // end debug

        console.log('BUYYYYY CREATE', $scope.isHybridFlow);

        //Always check janrain
        if ($rootScope.ruiMethods.user.is.agent() && $scope.isHybridFlow) {
          that.isEmailValidationInProcess = false;
          $scope.processCreateUser();
        } else {
          // start processing...
          notifier.notify.processing();

          // check the email is already exist in Janrain.
          emailValidationService.isEmailExistInJanrainAndCRM($scope.createUser.email_address).then(
            function(resp) {
              that.isEmailValidationInProcess = false;
              if (resp.data) {
                if (resp.data.error) {
                  _satellite.setVar('error', 'FHSI | isEmailValidationInProcess  failed');
                  _satellite.track('bfa-fhsi-error');
                  console.log('verifyExistingJanrainCustomer', resp.data.error);

                  // stop processing => show error
                  notifier.notify.error({ errorCode: resp.data.error });
                } else {
                  if (resp.data.isExisted) {
                    // close processing modal
                    notifier.notify.done();

                    // show option modal
                    uteModal.open({
                      templateUrl: 'modules/checkout/views/existing-janrain-user-modal.html',
                      controller: 'existingJanrainUserModalCtrl',
                      size: 'md',
                      data: {
                        focusEmail: focusEmail
                      }
                    });

                    // if (!$rootScope.ruiMethods.user.is.agent()) {
                    //   $translate('global.error.inline.email.existing').then(function (translation) {
                    //     openDecisionModal(translation);
                    //   });
                    // } else {
                    //   $translate('retail.error.inline.email.existing').then(function (translation) {
                    //     openDecisionModal(translation);
                    //   });
                    // }
                  } else {
                    $scope.processCreateUser();
                  }
                }
              } else {
                console.log('verifyExistingJanrainCustomer', resp.status);
                notifier.notify.error();
              }
            },
            function(resp) {
              // error handling
              that.isEmailValidationInProcess = false;
              console.log('verifyExistingJanrainCustomer', resp.status);
              _satellite.setVar('error', 'FHSI | isEmailValidationInProcess  failed');
              _satellite.track('bfa-fhsi-error');
              notifier.notify.error();
            }
          );
        }

        // required data:
        // streetName
        // streetNumber
        // streetType
        // streetDirection
        // city
        // province
        // country
        // postalCode
      }

      // TODO TBD
      function focusEmail() {
        document.getElementById('email').focus();
        document.getElementById('email').select();
      }
    }
  ]);
})();
